import React from 'react'

import { SkeletonIcon, SkeletonText } from '@offerzen/pinata-shame'
import SkeletonSection from '../SkeletonSection'

import styles from './styles'

const SkeletonEmploymentPreferences = () => (
  <SkeletonSection titleWidth={260} className={styles.body}>
    <For each="row" of={[0, 1]}>
      <div key={row} className={styles.employmentPreference}>
        <div className={styles.title}>
          <SkeletonIcon size="medium" theme="dark" />
          <SkeletonText theme="dark" width={100} />
        </div>

        <SkeletonText className={styles.details} theme="dark" width={220} />
      </div>
    </For>
  </SkeletonSection>
)

export default SkeletonEmploymentPreferences
